module.exports = __webpack_public_path__ + "static/media/PRISM_6500.93625878.jpg";